import { useTranslation } from "react-i18next";

import { PrimaryButton } from "_components/atoms/button";
import Icon              from "_components/atoms/icon";
import Typography        from "_components/atoms/typography";
import useStyles         from "_styles/atoms/emptyView";

const EmptyView = ( { customMsg, text, isFromUserProfile, styleProp, subHeading, enableButton = false, btnText, btnHandler } ) => {
	const { classes } = useStyles ( undefined, { name: "empty-view" } );
	const { t }       = useTranslation ();
	const title       = customMsg || ( text || isFromUserProfile ? t ( "empty_feed" ) : t ( "empty_feed_false" ) );

	return (
		<div className = { classes.emptyContainer }>
			<div className = { classes.textContainer }>
				<Icon
					className = { classes.iconStyle }
					name      = "emptyFeed"
					style     = { styleProp }
				/>

				<Typography
					className = "fontBold"
					color     = "secondary"
					title     = { title }
				/>

				<Typography
					color     = "secondary"
					title     = { subHeading }
				/>

				{enableButton && (
					<PrimaryButton
						onClick = { btnHandler }
						size    = "small"
						title   = { btnText }
					/>
				)}
			</div>
		</div>
	);
};

export default EmptyView;
